import { render, staticRenderFns } from "./MerchantLoginHeader.vue?vue&type=template&id=10c6cafa&scoped=true&"
import script from "./MerchantLoginHeader.vue?vue&type=script&lang=ts&"
export * from "./MerchantLoginHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantLoginHeader.vue?vue&type=style&index=0&id=10c6cafa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6cafa",
  null
  
)

export default component.exports